import GoogleIcon from '@mui/icons-material/Google';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import { UserCredential } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { loginWithGoogle } from '../core/auth';
import { auth } from '../core/firebase';
import { ISignupSchema } from './schema';

export default function ThirdPartySignin(props: ISignupSchema) {
  const {onSuccess, onError} = props;
  const [user] = useAuthState(auth);
  const [error, setError] = useState<null | Error>(null);

  const handleLoginGoogle = () => {
    loginWithGoogle()
      .then((cred: UserCredential) => {
        if (cred.user) {
          if (onSuccess) {
            onSuccess(cred);
          }
        } else {
          setError(new Error(`Could not login with google service at this time`));
        }
      })
      .catch((err: Error) => {
        setError(err);
      });
  };

  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
  }, [error]);

  return (
    <Grid container direction="column" alignItems="center">

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        message={error ? error.message : ''}
      />

      <Button
        onClick={handleLoginGoogle}
        startIcon={<GoogleIcon/>}
        variant="outlined"
        sx={{
          borderColor: '#FFF',
          color: '#FFF'
        }}
      >
        Sign In
      </Button>

    </Grid>
  );
}
